// Shared frontend constants — keep in sync with backend Literal types.

export const DOC_TYPES = [
    { value: "bank_statement", label: "Bank statement" },
    { value: "invoice", label: "Invoice" },
    { value: "receipt", label: "Receipt" },
    { value: "payroll_report", label: "Payroll report" },
    { value: "stripe_report", label: "Stripe / e-commerce report" },
    { value: "loan_statement", label: "Loan statement" },
    { value: "tax_correspondence", label: "Tax authority correspondence" },
    { value: "gst_support", label: "GST supporting document" },
    { value: "contractor_record", label: "Contractor record" },
    { value: "shareholder_document", label: "Shareholder document" },
    { value: "other", label: "Other" },
];

export const REQUEST_CATEGORIES = [
    { value: "gst", label: "GST return" },
    { value: "year_end", label: "Year-end pack" },
    { value: "monthly", label: "Monthly bookkeeping" },
    { value: "payroll", label: "Payroll" },
    { value: "missing_receipts", label: "Missing receipts" },
    { value: "review_support", label: "Review / audit support" },
    { value: "other", label: "Other" },
];

export const MESSAGE_CATEGORIES = [
    { value: "doc_issue", label: "Document issue" },
    { value: "upload_question", label: "Upload question" },
    { value: "tech_help", label: "Technical help" },
    { value: "accounting_question", label: "Tax / accounting question" },
    { value: "review_support", label: "Review / audit support" },
    { value: "access_issue", label: "Access / login issue" },
    { value: "general", label: "General" },
];

export const HELP_CATEGORIES = [
    { value: "all", label: "All articles" },
    { value: "upload", label: "Uploading documents" },
    { value: "bank_statement", label: "Bank statements" },
    { value: "xero", label: "Xero help" },
    { value: "stripe", label: "Stripe help" },
    { value: "authenticator", label: "Authenticator / 2FA" },
    { value: "ird", label: "IRD" },
    { value: "portal", label: "Portal usage" },
    { value: "general", label: "General" },
];

export const ENTITY_TYPES = [
    { value: "sole_trader", label: "Sole trader" },
    { value: "company", label: "Company" },
    { value: "trust", label: "Trust" },
    { value: "partnership", label: "Partnership" },
    { value: "individual", label: "Individual" },
];

export const PRIORITIES = [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
    { value: "urgent", label: "Urgent" },
];

export const STATUS_LABELS = {
    open: "Open",
    in_progress: "In progress",
    completed: "Completed",
    cancelled: "Cancelled",
    pending_review: "Pending review",
    accepted: "Accepted",
    needs_more_info: "Needs more info",
    rejected: "Rejected",
    resolved: "Resolved",
    todo: "To do",
    done: "Done",
    draft: "Draft",
    submitted: "Submitted",
    needs_changes: "Needs changes",
};

export const STATUS_TONES = {
    open: "blue",
    in_progress: "amber",
    completed: "green",
    cancelled: "grey",
    pending_review: "amber",
    accepted: "green",
    needs_more_info: "amber",
    rejected: "red",
    resolved: "green",
    todo: "grey",
    done: "green",
    draft: "grey",
    submitted: "blue",
    needs_changes: "amber",
};

export function labelFor(list, value) {
    return list.find((x) => x.value === value)?.label ?? value;
}

export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            // strip data: prefix
            const idx = String(result).indexOf("base64,");
            resolve(idx >= 0 ? String(result).slice(idx + 7) : String(result));
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function formatDate(value) {
    if (!value) return "—";
    try {
        const d = new Date(value);
        return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
    } catch (e) {
        return value;
    }
}

export function formatDateTime(value) {
    if (!value) return "—";
    try {
        return new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
    } catch (e) {
        return value;
    }
}

export function relativeTime(value) {
    if (!value) return "";
    const d = new Date(value);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
    return formatDate(value);
}
